import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import cx from 'classnames'
import get from 'lodash/get'
import GoogleAnalytics from 'react-ga'

import Box from '../Box'

import LineChart from '../LineChart'
import { dateString } from '../helpers/propTypes'

/* Main component ----------------------------------------------------------- */
export default function LineChartsByRoom({
  id,
  title,
  icon,
  description = '',
  className,
  fromDate,
  toDate,
  fetchReportFunction,
  rooms = [],
  children,
}) {
  const [selectedRoomId, setSelectedRoomId] = useState(get(rooms, [0, 'id']))

  function setSelectedRoom(roomId) {
    setSelectedRoomId(roomId)
    GoogleAnalytics.event({
      category: 'Line charts',
      action: 'Change room',
    })
  }

  if (rooms.length === 0) {
    return null
  }

  const selectedRoomIndex = R.findIndex(R.propEq('id', selectedRoomId))(rooms)

  const selectedRoom = rooms[selectedRoomIndex]

  return (
    <div className="ph2 ph3-l pb3 pb4-l w-100 w-50-ns w-50-print" id={id}>
      <Box className="flex flex-column" title={title} icon={icon}>
        <div className={cx(className, 'mt4')}>
          {selectedRoomId && (
            <LineChart
              roomId={selectedRoomId}
              roomName={selectedRoom.name}
              fromDate={fromDate}
              toDate={toDate}
              prevRoom={rooms[selectedRoomIndex - 1]}
              nextRoom={rooms[selectedRoomIndex + 1]}
              setSelectedRoom={setSelectedRoom}
              fetchReportFunction={fetchReportFunction}
            />
          )}
          {rooms.length > 1 && (
            <div className="tc">
              {rooms.map((r) => {
                const isSelected = r.id === selectedRoomId
                return (
                  <button
                    className={cx(
                      'pointer bn pa1 bg-transparent',
                      isSelected ? 'moon-gray' : 'orange'
                    )}
                    onClick={() => setSelectedRoom(r.id)}
                    title={r.name}
                    key={r.id}
                  >
                    <svg width="10" height="10" className="db">
                      <circle
                        cx="5"
                        cy="5"
                        r={isSelected ? 5 : 4}
                        fill="currentColor"
                      />
                    </svg>
                  </button>
                )
              })}
            </div>
          )}
          <p className="moon-gray f7 mt3 mb0 pt3 lh-copy bt b--light-silver h-auto">
            {description}
          </p>
          {children}
        </div>
      </Box>
    </div>
  )
}

LineChartsByRoom.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  fromDate: dateString,
  toDate: dateString,
  fetchReportFunction: PropTypes.func.isRequired,
  rooms: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  children: PropTypes.node,
}
